import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import GuidedMode from '../GuidedMode/GuidedMode';
import AdvancedMode from '../AdvancedMode/AdvancedMode';
import ValidatePassword from '../ValidatePassword/ValidatePassword';

const tabPaths = ['/guide', '/advanced', '/validate'];
const tabTitles = ['Everyday', 'Advanced', 'Validate'];

const PasswordTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  // Sync tabs with route changes
  useEffect(() => {
    const tabIndex = tabPaths.indexOf(location.pathname);
    setActiveTab(tabIndex === -1 ? 0 : tabIndex); // Default to the first tab if the path doesn't match
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    navigate(tabPaths[newValue]);
  };

  return (
    <Box sx={{ width: '100%', minHeight: '400px' }}>
      {/* Tab Navigation */}
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant="fullWidth"
        centered
        textColor="primary"
        indicatorColor="primary"
        sx={{
          marginBottom: '1rem',
          '& .MuiTab-root': {
            fontWeight: 'normal',
            fontSize: '1.1rem',
          },
        }}
      >
        {tabTitles.map((title, index) => (
          <Tab
            key={index}
            label={title}
            component="h1"
            sx={{
              fontSize: '1.1rem', // Maintain current font size
              fontWeight: 'bold',
              textTransform: 'none',
              '&:focus': {
                outline: 'none',
              },
            }}
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ marginTop: '1rem' }}>
        {activeTab === 0 && <GuidedMode />}
        {activeTab === 1 && <AdvancedMode />}
        {activeTab === 2 && <ValidatePassword />}
      </Box>
    </Box>
  );
};

export default PasswordTabs;
